import script from "./withdrawView.vue?vue&type=script&setup=true&lang=ts"
export * from "./withdrawView.vue?vue&type=script&setup=true&lang=ts"

import "./withdrawView.vue?vue&type=style&index=0&id=11edd724&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11edd724"]])

export default __exports__